const aaa = [
	{
		path: "lifeservice",
		component: () => import("@/views/chanpin/lifeservice/lifeservice.vue"),
		meta:{title:'生活服务',keepAlive:true},
	},
	{
		path: "addlifeservice",
		component: () => import("@/views/chanpin/lifeservice/addlifeservice.vue"),
		meta:{title:'编辑生活服务'},
	},
    {
		path: "relationconsum",
		component: () => import("@/views/chanpin/consumables/relationconsum.vue"),
		meta:{title:'关联耗材'},
	}

]
export default aaa;